<template>
</template>

<script>
    import _ from 'lodash';
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapGetters } from 'vuex';

    export default {
        name: 'Plot',
        props: [
            'data',
            'active',
            'link',
            'standalone'
        ],
        data () {
            return {
                isIE: false,
                widget: null,
                plotId: null
            };
        },
        computed: {
            ...mapGetters([
                'isOfflineMode',
                'isOnline',
                'isReviewUse',
                'language',
                'protocol'
            ]),
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.isIE = window.navigator.msPointerEnabled;
            this.render();
            EventBus.$on('plot_SetActive', (item, subitem) => {
                this.setActive(item, subitem);
            });
        },
        methods: {
            setActive(item, subitem) {
                let localData = _.cloneDeep(this.data);
                localData.items.filter(el => el.id === item.id)[0].loaded = true;
                if (subitem) {
                    if (!subitem.active) {
                        localData.items.filter(el => el.active).forEach(el => el.active = false);
                        localData.items.filter(el => el.id === item.id)[0].submenu.filter(el => el.active).forEach(el => el.active = false);
                        localData.items.filter(el => el.id === item.id)[0].active = true;
                        localData.items.filter(el => el.id === item.id)[0].submenu.filter(el => el.text === subitem.text)[0].active = true;
                        localData.items.filter(el => el.id === item.id)[0].link = subitem.link;
                        localData.widgetType = item.id;
                        EventBus.$emit('updateSidebar', localData, false);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: item.id,
                            link: subitem.link,
                            active: true,
                            widgetType: item.id
                        });
                    } else {
                        if (!item.active) {
                            localData.items.filter(el => el.active).forEach(el => el.active = false);
                            localData.items.filter(el => el.id === item.id)[0].active = true;
                            localData.widgetType = item.id;
                            EventBus.$emit('updateSidebar', localData, false);
                            EventBus.$emit('updateLoadedWidgets', {
                                id: item.id,
                                link: item.link,
                                active: true,
                                widgetType: item.id
                            });
                        }
                    }
                }
                else {
                    if (!item.active && !item.submenu) {
                        localData.items.filter(el => el.active).forEach(el => el.active = false);
                        localData.items.filter(el => el.id === item.id)[0].active = true;
                        localData.widgetType = item.id;
                        EventBus.$emit('updateSidebar', localData, false);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: item.id,
                            link: item.link,
                            active: true,
                            widgetType: item.id
                        });
                    }
                }
            },
            render() {
                let defaultLoadedWidget = {};
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/lot' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                if (this.isOfflineMode && !urlLink.includes('&offline'))
                    urlLink += '&offline';
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        let paramsUrl = new URL(urlLink);
                        payload.plotId = paramsUrl.searchParams.get("id");
                        payload.type = 'plot';
                        payload.widgetType = 'plot';
                        if (!this.standalone)
                            payload = Object.assign(payload, { widgetTitle: this.data.widgetTitle });
                        if (payload.language)
                            this.$i18n.locale = payload.language;

                        payload.items.forEach(el => {
                            if (!this.isOnline && this.isOfflineMode)
                                if (['virtual-tour', 'sunshine', 'drone-floor-view'].includes(el.id))
                                    el.active = false;
                                else{
                                    el.active = true;
                                    if (el.submenu)
                                        el.submenu[0].active = true;
                                }

                            if (el.submenu) {
                                let activeItem = el.submenu.filter(item => !!item.active);
                                if (activeItem.length) {
                                    if (!this.isOnline && this.isOfflineMode) {
                                        if (!['virtual-tour', 'sunshine', 'drone-floor-view'].includes(el.id)) {
                                            this.$set(el, 'loaded', true);
                                            this.$set(el, 'active', true);
                                            this.$set(el, 'link', activeItem[0].link);
                                            defaultLoadedWidget = {
                                                id: el.id,
                                                link: el.link,
                                                active: true,
                                                widgetType: el.id
                                            };
                                        }
                                    } else {
                                        this.$set(el, 'loaded', true);
                                        this.$set(el, 'active', true);
                                        this.$set(el, 'link', activeItem[0].link);
                                        defaultLoadedWidget = {
                                            id: el.id,
                                            link: el.link,
                                            active: true,
                                            widgetType: el.id
                                        };
                                    }
                                }
                            } else {
                                if (el.active) {
                                    this.$set(el, 'loaded', true);
                                    defaultLoadedWidget = {
                                        id: el.id,
                                        link: el.link,
                                        active: true,
                                        widgetType: el.id
                                    };
                                }
                            }
                        });


                        // payload = Object.assign(payload, { activeHotspot: this.activeHotspot });
                        EventBus.$emit('updateSidebar', payload, false);
                        EventBus.$emit('updateLoadedWidgets', defaultLoadedWidget);
                        EventBus.$emit('trackWidget', payload.tracking);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            triggerResize() {
                if (this.isIE) {
                    let evt = window.document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                } else
                    window.dispatchEvent(new Event('resize'));
            }
        },
        watch: {
            active(val) {
                if (val)
                    this.render();
            },
            link() {
                if (this.active)
                    this.render();
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/PlotWidget.vue